import { CardOnFileActions, CardOnFileActionsProps } from './actions';

export type CardOnFileActionsJustifiProps = CardOnFileActionsProps;

export const CardOnFileActionsJustifi = (props: CardOnFileActionsJustifiProps) => {
  return <CardOnFileActions {...props} />;
};
